import * as v from 'valibot';

export const allPermissions = [
	'admin.users',
	'admin.users.view.all',
	'admin.users.view.company',
	'admin.users.view.region',
	'admin.users.view.office',
	'admin.users.edit',
	'admin.users.add',
	'admin.users.active',
	'admin.users.reportsto',
	'admin.users.directreport',
	'admin.users.underwriterreportsto',
	'admin.users.underwriterdirectreport',
	'admin.default',
	'home.claim.dashboard',
	'home.claim.table',
	'home.claim.reassign',
	'home.claim.create',
	'home.risk.dashboard',
	'home.risk.table',
	'home.risk.reassign',
	'home.risk.create',
	'claim',
	'claim.view',
	'claim.questionnaire.view',
	'claim.document.view',
	'claim.calculation.view',
	'claim.activitylog.view',
	'claim.extract',
	'claim.extract.details',
	'claim.extract.data',
	'claim.document.upload',
	'claim.document.download',
	'claim.close',
	'claim.reopen',
	'claim.questionnaire.complete',
	'claim.questionnaire.edit',
	'claim.edit',
	'claim.report',
	'claim.report.approve',
	'claim.data.addremove',
	'claim.data.category.amend',
	'claim.data.calculation.category.amend',
	'claim.data.submitted.value.amend',
	'claim.document.approve',
	'claim.document.deny',
	'claim.handler.claim',
	'claim.own.claim',
	'claim.sales.download',
	'claim.sales.input.extract',
	'claim.sales.extract',
	'claim.sales.loss.extract',
	'claim.sales.edit',
	'claim.sales.input.verify.reject',
	'risk',
	'risk.activitylog.view',
	'risk.admin.users',
	'risk.admin.users.active',
	'risk.admin.users.add.headofunderwriting',
	'risk.admin.users.add.leadunderwriter',
	'risk.admin.users.add.underwriterassistant',
	'risk.admin.users.add.underwritingadmin',
	'risk.admin.users.edit',
	'risk.admin.users.view.all',
	'risk.admin.users.view.company',
	'risk.admin.users.view.office',
	'risk.admin.users.view.region',
	'risk.calculation.view',
	'risk.close',
	'risk.reopen',
	'risk.data.addremove',
	'risk.document.download',
	'risk.document.upload',
	'risk.document.view',
	'risk.edit',
	'risk.extract',
	'risk.extract.details',
	'risk.extract.data',
	'risk.handler.risk',
	'risk.report',
	'risk.report.approve',
	'risk.view',
	'shared.data.view',
	'shared.data.category.amend',
	'shared.data.value.amend',
] as const;

export const Permission = v.picklist(allPermissions);

export type Permission = v.InferOutput<typeof Permission>;
